export default "__VITE_ASSET__a9ee6bd2__"